import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import Paper from '@material-ui/core/Paper';

import { dialogTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import DownloadReportButton from '@reports/components/DownloadReportButton';
import DownloadReportModal from '@reports/components/DownloadReportModal';
import { REPORT_EDIT_MODES } from '@routes/constants/reports';
import { ReportEditMode } from '@routes/types';
import { NEW_REPORT_NAME } from '@shared/constants';
import useProjectPageBreadcrumbs from '@shared/hooks/useProjectPageBreadcrumbs';

import styles from './ReportHeader.module.scss';

type ReportHeaderProps = {
  canEdit: boolean;
  editMode: ReportEditMode;
  name: string;
};

type ReportHeaderParams = {
  projectName: string;
  reportName: string;
  workspace: string;
};

const ReportHeaderNewDesign = ({
  canEdit,
  editMode,
  name
}: ReportHeaderProps) => {
  const dispatch = useDispatch();
  const { reportName } = useParams<ReportHeaderParams>();
  useProjectPageBreadcrumbs();

  const isDraft = reportName === NEW_REPORT_NAME;

  const handleDownloadClick = () => {
    const downloadReportModal = (
      <DownloadReportModal
        modalId={dialogTypes.DOWNLOAD_REPORT_MODAL}
        name={name}
      />
    );

    dispatch(
      alertsUtil.openCustomModal(
        dialogTypes.DOWNLOAD_REPORT_MODAL,
        downloadReportModal
      )
    );
  };

  const shouldSaveChanges = canEdit && editMode !== REPORT_EDIT_MODES.VIEW;

  return (
    <Paper className={styles.header} elevation={4}>
      <div className={styles.breadcrumbsSection}>
        {shouldSaveChanges && isDraft && (
          <div className={styles.draftLabel}>Draft</div>
        )}
      </div>

      <div className={styles.actionsSection}>
        <DownloadReportButton
          shouldDisplayText
          onDownload={handleDownloadClick}
        />
      </div>
    </Paper>
  );
};

export default ReportHeaderNewDesign;
